import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';

function CommonSalesQuotationFields({ onDataChange, initialData }) {
    const [customerOptions, setcustomerOptions] = useState([]);
    const [customerSearch, setcustomerSearch] = useState(" ");
    const [customer, setcustomer] = useState(initialData?.customer || null);
    const [iscustomerOpen, setIscustomerOpen] = useState(false);

    const [customerDetails, setcustomerDetails] = useState({
        contactperson: initialData?.customerDetails?.contactperson || '',
        contactno: initialData?.customerDetails?.contactno || '',
        email: initialData?.customerDetails?.email || '',
        freight: initialData?.customerDetails?.freight || '',
        packingandforwarding: initialData?.customerDetails?.packingandforwarding || '',
        paymentterm: initialData?.customerDetails?.paymentterm || ''
    });

    const [customerAddresses, setcustomerAddresses] = useState([]);
    const [customerMultipleAddress, setcustomerMultipleAddress] = useState(initialData?.customerMultipleAddress || null);


    // Handle customer details change
    const handleCustomerDetailsChange = (field, value) => {
        setcustomerDetails(prev => ({
            ...prev,
            [field]: value
        }));
    };


    useEffect(() => {
        if (initialData?.customer?.value) {
            getcustomerAddresses(initialData.customer.value);
        }
    }, [initialData]);

    const handleSearchChangecustomer = debounce((inputValue) => {
        setcustomerSearch(inputValue || " ");
    }, 300);

    useEffect(() => {
        getcustomerData();
    }, [customerSearch]);

    const getcustomerData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}customer/page/0/10/asc/id/${encodeURIComponent(customerSearch)}`,
                { headers: authHeader() }
            );

            const customers = response.data.Index || response.data.data || [];

            setcustomerOptions(
                customers.map((s) => ({
                    value: s.id,
                    label: s.companyname,
                    contactperson: s.contactperson,
                    contactno: s.contactno,
                    email: s.email,
                    freight: s.freight,
                    packingandforwarding: s.packingandforwarding,
                    paymentterm: s.paymentterm,
                }))
            );
        } catch (error) {
            console.error("Error fetching customer data", error);
        }
    };

    const getcustomerAddresses = async (id) => {
        try {
            const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
                headers: authHeader(),
            });
            setcustomerAddresses(response.data.map(addr => ({
                value: addr.id,
                label: addr.customeraddress,
            })));
        } catch (error) {
            console.error("Error fetching customer addresses", error);
        }
    };

    const handlecustomerChange = (selected) => {
        setcustomer(selected);
        if (selected) {
            setcustomerDetails({
                contactperson: selected.contactperson,
                contactno: selected.contactno,
                email: selected.email,
                freight: selected.freight,
                packingandforwarding: selected.packingandforwarding,
                paymentterm: selected.paymentterm,
            });
            getcustomerAddresses(selected.value);
            setIscustomerOpen(true); // Auto-expand when customer is selected
        } else {
            setcustomerDetails({
                contactperson: '',
                contactno: '',
                email: '',
                freight: '',
                packingandforwarding: '',
                paymentterm: ''
            });
        }
        setcustomerMultipleAddress(null);
    };

    const handleDataUpdate = () => {
        if (onDataChange) {
            onDataChange({
                customer,
                customerDetails,
                customerMultipleAddress,
            });
        }
    };

    useEffect(() => {
        handleDataUpdate();
    }, [customer, customerDetails, customerMultipleAddress]);

    const togglecustomerSection = () => {
        setIscustomerOpen(!iscustomerOpen);
    };

    return (
        <>
            {/* Custom Accordion for customer Section */}
            <br />
            <div className="supplier-accordion-container">
                <div
                    className={`supplier-accordion-header ${iscustomerOpen ? 'supplier-accordion-open' : ''}`}
                    onClick={togglecustomerSection}
                >
                    <h7>customer Information</h7>
                    <span className="supplier-accordion-icon">
                        {iscustomerOpen ? '−' : '+'}
                    </span>
                </div>

                <div className={`supplier-accordion-content ${iscustomerOpen ? 'supplier-accordion-content-show' : ''}`}>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>customer</Form.Label>
                                <Select
                                    options={customerOptions}
                                    onChange={handlecustomerChange}
                                    onInputChange={handleSearchChangecustomer}
                                    value={customer}
                                    placeholder="Select customer"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Contact Person</Form.Label>
                                <Form.Control
                                    value={customerDetails.contactperson}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    value={customerDetails.contactno}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    value={customerDetails.email}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>customer Address</Form.Label>
                                <Select
                                    options={customerAddresses}
                                    value={customerMultipleAddress}
                                    onChange={(val) => setcustomerMultipleAddress(val)}
                                    isClearable
                                    placeholder="Select address"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Freight</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={customerDetails.freight}
                                    onChange={e => handleCustomerDetailsChange('freight', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Packing & Forwarding</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={customerDetails.packingandforwarding}
                                    onChange={e => handleCustomerDetailsChange('packingandforwarding', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Payment Term</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={customerDetails.paymentterm}
                                    onChange={e => handleCustomerDetailsChange('paymentterm', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}
export default CommonSalesQuotationFields;
